/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_c_garden_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GARDEN has three common anagrams: DANGER, RANGED, and GANDER — all built from the same six letters (G, A, R, D, E, N) in a different order. DANGER is the one most people recognize, since it reads as the opposite of what a garden usually represents.`)
};

const es_wu_c_garden_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GARDEN tiene tres anagramas comunes: DANGER, RANGED y GANDER —todos construidos con las mismas seis letras (G, A, R, D, E, N) en otro orden. DANGER es el que más gente reconoce, ya que se lee como lo opuesto de lo que un garden (jardín) suele representar.`)
};

const de_wu_c_garden_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GARDEN hat drei gebräuchliche Anagramme: DANGER, RANGED und GANDER — alle aus denselben sechs Buchstaben (G, A, R, D, E, N) in anderer Reihenfolge gebildet. DANGER erkennen die meisten zuerst, da es sich wie das Gegenteil dessen liest, wofür ein Garten normalerweise steht.`)
};

const nl_wu_c_garden_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GARDEN heeft drie gangbare anagrammen: DANGER, RANGED en GANDER — allemaal opgebouwd uit dezelfde zes letters (G, A, R, D, E, N) in een andere volgorde. DANGER is degene die de meeste mensen herkennen, omdat het als het tegenovergestelde leest van waar een garden (tuin) meestal voor staat.`)
};

const fr_wu_c_garden_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GARDEN a trois anagrammes courantes : DANGER, RANGED et GANDER — toutes construites à partir des mêmes six lettres (G, A, R, D, E, N) dans un ordre différent. DANGER est celle que la plupart des gens reconnaissent, car elle se lit comme l'opposé de ce qu'un jardin représente habituellement.`)
};

const it_wu_c_garden_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GARDEN ha tre anagrammi comuni: DANGER, RANGED e GANDER — tutti costruiti dalle stesse sei lettere (G, A, R, D, E, N) in ordine diverso. DANGER è quello che la maggior parte delle persone riconosce, dato che suona come l'opposto di ciò che un giardino di solito rappresenta.`)
};

const pt_br2_wu_c_garden_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GARDEN tem três anagramas comuns: DANGER, RANGED e GANDER — todas construídas com as mesmas seis letras (G, A, R, D, E, N) em ordem diferente. DANGER é a mais reconhecida, já que soa como o oposto do que um jardim costuma representar.`)
};

const pt_wu_c_garden_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GARDEN tem três anagramas comuns: DANGER, RANGED e GANDER — todos construídos com as mesmas seis letras (G, A, R, D, E, N) por ordem diferente. DANGER é o que a maioria das pessoas reconhece, já que soa como o oposto do que um jardim normalmente representa.`)
};

const ja_wu_c_garden_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GARDENにはDANGER、RANGED、GANDERという3つの一般的なアナグラムがあります — いずれも同じ6文字（G, A, R, D, E, N）を異なる順序で使っています。DANGERは最も多くの人が気づく単語です。gardenが通常表すものとは正反対の意味に読めるからです。`)
};

const zh_wu_c_garden_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GARDEN 有三个常见的易位构词：DANGER、RANGED 和 GANDER——都是用相同的六个字母（G、A、R、D、E、N）以不同顺序组成的。DANGER 是大多数人最容易认出的一个，因为它读起来与花园通常所代表的意象截然相反。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_c_garden_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_c_garden_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_c_garden_faq1_a", locale)
	if (locale === "en") return en_wu_c_garden_faq1_a(inputs)
	if (locale === "es") return es_wu_c_garden_faq1_a(inputs)
	if (locale === "de") return de_wu_c_garden_faq1_a(inputs)
	if (locale === "nl") return nl_wu_c_garden_faq1_a(inputs)
	if (locale === "fr") return fr_wu_c_garden_faq1_a(inputs)
	if (locale === "it") return it_wu_c_garden_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_wu_c_garden_faq1_a(inputs)
	if (locale === "pt") return pt_wu_c_garden_faq1_a(inputs)
	if (locale === "ja") return ja_wu_c_garden_faq1_a(inputs)
	return zh_wu_c_garden_faq1_a(inputs)
};